export enum PaymentProvider {
    AUTH_NET = 'authdotnet',
    CHASE_DHPP = 'chase_dhpp',
}
